<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    userInfo: {},
  }),
  methods: {},
}
</script>

<style>
@import './assets/css/main.css';
@import './assets/css/BX_MS06_main_style.css';

/* 全局覆盖 Element UI 遮罩层，避免打开弹框时黑/白闪烁 */
.v-modal-enter,
.v-modal-leave {
  animation: none !important;
}
.v-modal {
  transition: none !important;
  background: rgba(0, 0, 0, 0.5) !important; /* 固定为半透明黑 */
}

/* 限制el-dropdown-menu的高度和添加滚动 */
.el-popover,
.el-dropdown-menu,
.custom-table-checkbox,
.el-select-dropdown,
.el-picker-panel,
.el-autocomplete-suggestion,
.el-cascader__dropdown,
.el-time-panel,
.v-menu__content {
  max-height: 600px !important;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  display: inline-block;
  max-width: 80%;
  /* overflow-y: auto; */
  /* overflow-x: hidden; */
  contain: content;
  box-shadow:
    0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14) !important;
  border-radius: 4px !important;
}

.v-menu__content {
  background: var(--theme-surface-bg, #f3f6fb) !important;
  border: 1px solid rgba(var(--theme-accent-rgb, 93, 123, 218), 0.2) !important;
  color: var(--theme-text-primary, #1f2937) !important;
}

.custom-table-checkbox {
  max-height: 320px !important;
  padding: 10px 12px !important;
}

.el-checkbox__label,
.el-radio__label,
.el-pagination__total,
.el-pagination__jump {
  color: var(--theme-text-primary, #1f2937) !important;
}

/* 美化滚动条 */
.el-popover::-webkit-scrollbar,
.el-dropdown-menu::-webkit-scrollbar,
.custom-table-checkbox::-webkit-scrollbar,
.v-menu__content::-webkit-scrollbar {
  width: 6px;
}

.el-popover::-webkit-scrollbar-thumb,
.el-dropdown-menu::-webkit-scrollbar-thumb,
.custom-table-checkbox::-webkit-scrollbar-thumb,
.v-menu__content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.el-popover::-webkit-scrollbar-track,
.el-dropdown-menu::-webkit-scrollbar-track,
.custom-table-checkbox::-webkit-scrollbar-track,
.v-menu__content::-webkit-scrollbar-track {
  background: #f5f7fa;
}

/* 调整下拉菜单项的样式 */
.el-dropdown-menu__item {
  line-height: 32px !important;
  padding: 0 12px !important;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.el-checkbox {
  margin-right: 0 !important;
}

.el-checkbox__label,
.el-radio__label {
  transition: color 0.2s ease;
}

.el-checkbox__inner,
.el-radio__inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.3) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.88) !important;
}

.el-checkbox__inner:hover,
.el-radio__inner:hover,
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-radio__input.is-focus .el-radio__inner {
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-radio__input.is-checked .el-radio__inner {
  background: var(--theme-accent-color, #5d7bda) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label,
.el-checkbox__input.is-indeterminate + .el-checkbox__label,
.el-radio__input.is-checked + .el-radio__label {
  color: var(--theme-text-primary, #1f2937) !important;
  font-weight: 600;
}

.el-table .el-checkbox__inner,
.ve-table .el-checkbox__inner,
.ve-table-checkbox-wrapper .el-checkbox__inner,
.el-table-column--selection .el-checkbox__inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.34) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.96) !important;
}

.el-table .el-checkbox__input.is-checked .el-checkbox__inner,
.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.ve-table .el-checkbox__input.is-checked .el-checkbox__inner,
.ve-table .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.ve-table-checkbox-wrapper .el-checkbox__input.is-checked .el-checkbox__inner,
.ve-table-checkbox-wrapper .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-table-column--selection .el-checkbox__input.is-checked .el-checkbox__inner,
.el-table-column--selection .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: var(--theme-accent-color, #5d7bda) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-checkbox__input.is-disabled .el-checkbox__inner,
.el-radio__input.is-disabled .el-radio__inner {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.55) !important;
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.16) !important;
}

.el-checkbox__input.is-disabled + .el-checkbox__label,
.el-radio__input.is-disabled + .el-radio__label {
  color: var(--theme-text-secondary, #7d7d7d) !important;
}

.v-data-table .v-simple-checkbox .v-icon.primary--text,
.v-data-table .v-data-table__checkbox .v-icon.primary--text {
  color: var(--theme-color, #282f44) !important;
  caret-color: var(--theme-color, #282f44) !important;
}

.v-data-table .v-simple-checkbox .v-input--selection-controls__ripple.primary--text::before,
.v-data-table .v-data-table__checkbox .v-input--selection-controls__ripple.primary--text::before {
  background-color: var(--theme-color, #282f44) !important;
}

.ve-table .ve-checkbox .ve-checkbox-content .ve-checkbox-inner,
.ve-table-checkbox-wrapper .ve-checkbox .ve-checkbox-content .ve-checkbox-inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.4) !important;
  background-color: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.96) !important;
}

.ve-table .ve-checkbox:hover .ve-checkbox-inner,
.ve-table .ve-checkbox .ve-checkbox-content:hover .ve-checkbox-inner,
.ve-table .ve-checkbox .ve-checkbox-content .ve-checkbox-input:focus + .ve-checkbox-inner,
.ve-table-checkbox-wrapper .ve-checkbox:hover .ve-checkbox-inner,
.ve-table-checkbox-wrapper .ve-checkbox .ve-checkbox-content:hover .ve-checkbox-inner,
.ve-table-checkbox-wrapper
  .ve-checkbox
  .ve-checkbox-content
  .ve-checkbox-input:focus
  + .ve-checkbox-inner {
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.ve-table .ve-checkbox .ve-checkbox-content.ve-checkbox-checked .ve-checkbox-inner,
.ve-table-checkbox-wrapper .ve-checkbox .ve-checkbox-content.ve-checkbox-checked .ve-checkbox-inner {
  background-color: var(--theme-accent-color, #5d7bda) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.ve-table .ve-checkbox .ve-checkbox-content.ve-checkbox-checked::after,
.ve-table-checkbox-wrapper .ve-checkbox .ve-checkbox-content.ve-checkbox-checked::after {
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.ve-table .ve-checkbox .ve-checkbox-content.ve-checkbox-indeterminate .ve-checkbox-inner,
.ve-table-checkbox-wrapper
  .ve-checkbox
  .ve-checkbox-content.ve-checkbox-indeterminate
  .ve-checkbox-inner {
  background-color: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.96) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.ve-table .ve-checkbox .ve-checkbox-content.ve-checkbox-indeterminate .ve-checkbox-inner:after,
.ve-table-checkbox-wrapper
  .ve-checkbox
  .ve-checkbox-content.ve-checkbox-indeterminate
  .ve-checkbox-inner:after {
  background-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.92) !important;
  color: var(--theme-text-primary, #1f2937) !important;
}

.el-pagination button,
.el-pagination .el-pager li {
  color: var(--theme-text-primary, #1f2937) !important;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.el-pagination .el-pager li.active {
  color: var(--theme-accent-color, #5d7bda) !important;
  font-weight: 600;
}

.el-pagination button:hover,
.el-pagination .el-pager li:hover {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-pagination button:disabled,
.el-pagination button:disabled:hover {
  color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.36) !important;
  background: transparent !important;
}

.el-pagination .el-select .el-input__inner,
.el-pagination__editor.el-input .el-input__inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.26) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.96) !important;
  color: var(--theme-text-primary, #1f2937) !important;
}

.el-pagination .el-select .el-input__inner:hover,
.el-pagination .el-select .el-input.is-focus .el-input__inner,
.el-pagination__editor.el-input .el-input__inner:hover,
.el-pagination__editor.el-input .el-input__inner:focus {
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-pagination .el-select .el-input .el-select__caret,
.el-pagination .btn-prev .el-icon,
.el-pagination .btn-next .el-icon {
  color: inherit !important;
}

.el-pagination.is-background .el-pager li.active,
.el-pagination.is-background .el-pager li:hover,
.el-pagination.is-background .btn-next:hover,
.el-pagination.is-background .btn-prev:hover {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.14) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-button {
  transition:
    color 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}

.el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(
    .el-button--danger
  ):not(.el-button--info):not(.is-disabled):hover,
.el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(
    .el-button--danger
  ):not(.el-button--info):not(.is-disabled):focus {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.42) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-button--primary {
  background: var(--theme-accent-color, #5d7bda) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
  color: #ffffff !important;
}

.el-button--primary:hover,
.el-button--primary:focus,
.el-button--primary:active {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.92) !important;
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.92) !important;
  color: #ffffff !important;
}

.el-button--primary.is-plain {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.26) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:active {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.18) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-button--default:hover,
.el-button--default:focus,
.el-button--default:active {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.42) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.08) !important;
}

.el-input__inner,
.el-textarea__inner,
.el-input-number,
.el-input-number .el-input__inner {
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    color 0.2s ease,
    background-color 0.2s ease;
}

.el-input__inner:hover,
.el-textarea__inner:hover,
.el-select:hover .el-input__inner,
.el-cascader .el-input:hover .el-input__inner,
.el-input-number:hover .el-input__inner,
.el-input-number:hover .el-input-number__decrease,
.el-input-number:hover .el-input-number__increase {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.42) !important;
}

.el-input.is-focus .el-input__inner,
.el-textarea__inner:focus,
.el-select .el-input.is-focus .el-input__inner,
.el-cascader .el-input.is-focus .el-input__inner,
.el-input-number.is-controls-right .el-input__inner:focus,
.el-input-number .el-input__inner:focus {
  border-color: var(--theme-accent-color, #5d7bda) !important;
  box-shadow: 0 0 0 2px rgba(var(--theme-accent-rgb, 93, 123, 218), 0.1) !important;
}

.el-input-number__decrease:hover,
.el-input-number__increase:hover,
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover,
.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus,
.el-cascader-node:hover,
.el-picker-panel__shortcut:hover,
.el-date-table td.available:hover,
.el-month-table td .cell:hover,
.el-year-table td .cell:hover,
.el-time-panel__btn.confirm:hover,
.el-time-spinner__item:hover:not(.disabled):not(.active) {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover,
.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus,
.el-cascader-node:hover,
.el-date-table td.available:hover,
.el-month-table td .cell:hover,
.el-year-table td .cell:hover,
.el-time-spinner__item:hover:not(.disabled):not(.active) {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.08) !important;
}

.el-select-dropdown__item.selected,
.el-cascader-node.is-selectable.in-checked-path,
.el-cascader-node.in-active-path,
.el-date-table td.today span,
.el-date-table td.current:not(.disabled) span,
.el-month-table td.current:not(.disabled) .cell,
.el-month-table td.today .cell,
.el-year-table td.current:not(.disabled) .cell,
.el-year-table td.today .cell,
.el-picker-panel__link-btn,
.el-time-panel__btn.confirm,
.el-date-picker__header-label.active,
.el-date-picker__header-label:hover {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-picker-panel__shortcut.active {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-date-table td.current:not(.disabled) span,
.el-date-table td.selected span,
.el-date-table td.start-date span,
.el-date-table td.end-date span,
.el-month-table td.start-date .cell,
.el-month-table td.end-date .cell {
  background-color: var(--theme-accent-color, #5d7bda) !important;
  color: #fff !important;
}

.el-picker-panel__btn:hover,
.el-picker-panel__btn:focus {
  border-color: var(--theme-accent-color, #5d7bda) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-tabs__item:hover,
.el-tabs__item:focus,
.el-tabs__item.is-active {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-tabs__active-bar {
  background-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-menu-item:hover,
.el-submenu__title:hover,
.el-menu-item.is-active {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.alarm-setting-new .category-sidebar {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.78) !important;
  border-right: 1px solid rgba(var(--theme-accent-rgb, 93, 123, 218), 0.14) !important;
}

.alarm-setting-new .category-sidebar .el-menu,
.alarm-setting-new .category-sidebar .category-menu {
  background: transparent !important;
  border-right: none !important;
}

.alarm-setting-new .category-sidebar .el-menu-item {
  color: var(--theme-text-primary, #1f2937) !important;
  background: transparent !important;
  border-right: 3px solid transparent !important;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease !important;
}

.alarm-setting-new .category-sidebar .el-menu-item span {
  color: inherit !important;
}

.alarm-setting-new .category-sidebar .el-menu-item:hover,
.alarm-setting-new .category-sidebar .el-menu-item:focus {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.08) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.alarm-setting-new .category-sidebar .el-menu-item.is-active,
.alarm-setting-new .category-sidebar .el-menu-item.is-active:hover {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
  border-right-color: var(--theme-accent-color, #5d7bda) !important;
}

.alarm-tab-item {
  border-bottom: 4px solid transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease !important;
}

.alarm-tab-item:hover {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
}

.alarm-tab-item:hover .v-icon,
.alarm-tab-item:hover span,
.alarm-tab-item.active-tab .v-icon,
.alarm-tab-item.active-tab span {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-alarm-filter-card .filter-left-menu {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.88) !important;
  border-right: 1px solid rgba(var(--theme-accent-rgb, 93, 123, 218), 0.14) !important;
}

.el-alarm-filter-card .menu-item {
  color: var(--theme-text-primary, #1f2937) !important;
  border-left-color: transparent !important;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease !important;
}

.el-alarm-filter-card .menu-item:hover {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.08) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-alarm-filter-card .menu-item.active {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
  border-left-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-alarm-filter-card .category-section {
  border-bottom-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.08) !important;
}

.el-alarm-filter-card .filter-footer {
  border-top-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.72) !important;
}

.ve-loading {
  --sk-color: var(--theme-accent-color, #5d7bda) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.ve-loading .ve-loading-wave-rect,
.ve-loading .ve-loading-bounce-dot,
.ve-loading .ve-loading-flow-dot,
.ve-loading .ve-loading-grid-cube,
.ve-loading .ve-loading-pulse,
.ve-loading .ve-loading-plane {
  background-color: var(--theme-accent-color, #5d7bda) !important;
}

.ve-loading .ve-loading-spin-container,
.ve-loading .ve-loading-spin,
.ve-loading .ve-loading-spin-tip,
.ve-loading .ve-loading-text,
.ve-loading p,
.ve-loading span {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-loading-mask {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.84) !important;
}

.el-loading-spinner i,
.el-loading-spinner .el-loading-text {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-loading-spinner .el-loading-text {
  font-weight: 600;
}

.el-loading-spinner .path {
  stroke: var(--theme-accent-color, #5d7bda) !important;
}

/* 全局 el-dialog 头部/底部主题色 */
.el-dialog__header {
  background: var(--theme-color) !important;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-header{
  width: 100%;
}

.el-dialog__title {
  color: #ffffff !important;
  font-weight: 600;
}

.el-dialog__headerbtn {
  position: static !important;
  flex-shrink: 0;
  margin-left: auto;
  line-height: 1;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff !important;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: rgba(255, 255, 255, 0.7) !important;
}

.el-dialog__footer {
  background: var(--theme-color) !important;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.el-dialog__footer .el-button--default {
  background: transparent !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.el-dialog__footer .el-button--default:hover,
.el-dialog__footer .el-button--default:focus {
  border-color: #ffffff !important;
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.1) !important;
}

/* 确保v-menu内容正确显示 */
.v-menu__content .v-list {
  padding: 0;
}

.v-menu__content .v-list-item {
  min-height: 32px;
}
</style>
